import { ApiProductType } from '../../types/ProductTypes';

import { ActionType, GetActionType } from './model';

export const getActionType: GetActionType = ({ link, productType, articleUrl, actionType }) => {
  const outlinkServicePathname = '/outlink';
  // Check if link is internal
  try {
    const linkUrl = new URL(link);
    if (linkUrl.pathname === outlinkServicePathname) {
      return ActionType.RETAILER;
    }
    if (articleUrl.includes(linkUrl.hostname)) {
      return ActionType.INTERNAL;
    }
  } catch (_) {
    if (link.startsWith('/')) {
      return ActionType.INTERNAL;
    }
  }

  if (productType === ApiProductType.similar) {
    return ActionType.CHECK_RETAILER;
  }

  if (actionType) {
    return actionType;
  }

  return ActionType.RETAILER;
};
